import { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { auth } from '../lib/api';
import { ArrowLeft } from 'lucide-react';
import AuthFrame from '../components/AuthFrame';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await auth.forgotPassword({ email });
      setSubmitted(true);
      toast.success(response.message);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthFrame kicker="Password" title={submitted ? 'Check your notifications.' : 'Reset your password.'}>
      {!submitted ? (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="email" className="label">Email</label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field"
              placeholder="you@example.com"
            />
          </div>

          <button type="submit" disabled={loading} className="btn btn-accent w-full">
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      ) : (
        <p className="text-ink-secondary border-l-2 border-ink pl-4">
          If an account exists for that email, a reset link is waiting in its notifications (the bell icon).
        </p>
      )}

      <p className="mt-6">
        <Link to="/login" className="kicker inline-flex items-center gap-1 hover:text-ink">
          <ArrowLeft className="w-3 h-3" />
          Back to sign in
        </Link>
      </p>
    </AuthFrame>
  );
}
